export default __webpack_public_path__ + "static/media/notification-blue.7c350ac4.svg";